module.exports = __webpack_public_path__ + "img/maneken_pos_6_back.b1e0f497.png";